import { render, staticRenderFns } from "./DiscountTables.vue?vue&type=template&id=7f746902"
import script from "./DiscountTables.vue?vue&type=script&lang=js"
export * from "./DiscountTables.vue?vue&type=script&lang=js"
import style0 from "./DiscountTables.vue?vue&type=style&index=0&id=7f746902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports